/* The browser's geolocation call as a promise. The position is cached indefinitely, so asking
   again after it has been answered once costs nothing. */
export const deviceLocation = (timeout = 10000) =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not available"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => resolve({ lat: coords.latitude, lng: coords.longitude }),
      reject,
      { enableHighAccuracy: false, timeout, maximumAge: Infinity },
    );
  });
